import React, {Component} from "react";
import Api from "../../api/Api";
import './Trypi.css';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {history} from "../../routes/Routing";
import Authentication from "../../authentication/Authentication";
import Footer from "../footer/Footer";
import PisaasInstanceInfo from "../instances/PisaasInstanceInfo"
import Nav from "../../nav/Nav"
import InstancesButtons from "../instances/InstancesButtons";
import Loading from "../loading/Loading";
import PisaasCustomerSignUpPopUp from "../instances/PisaasCustomerSignUpPopUp";

const api = new Api();

export default class Trypi extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            requestingPisaasCustomerInstances: false,
            pisaasCustomerInstances: [],
            packageId: 8
        };

        this.authentication = new Authentication();
    };

    componentDidMount() {
        this.load()
        this.pisaasCustomerInstanceInterval = setInterval(this.pisaasCustomerInstancesRefresh, 10000);
    }

    componentWillUnmount() {
        if (this.pisaasCustomerInstanceInterval) {
            clearInterval(this.pisaasCustomerInstanceInterval);
        }
    };

    load = () => {
        this.setState({
            loading: true
        });

        api.pisaasFetchCustomerInstances(this.setPisaasCustomerInstances, function (err) {
            console.log(err);
            toast.error("Failed to load your instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    loadAfterCreate = () => {
        this.setState(
            {
                requestingPisaasCustomerInstances: true,
                loading: true
            });

        api.pisaasFetchCustomerInstances(this.setPisaasCustomerInstances, function (err) {
            console.log(err);
            toast.error("Failed to load your instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    pisaasCustomerInstancesRefresh = () => {
        const api = new Api();

        api.pisaasFetchCustomerInstances(this.setPisaasCustomerInstancesMaintainRequesting, function (err) {
            console.log(err);
            toast.error("Failed to refresh running instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    };

    setPisaasCustomerInstances = async (pisaasInstances) => {
        this.setState(
            {
                pisaasCustomerInstances: pisaasInstances,
                requestingPisaasCustomerInstances: false,
                loading: false
            });
    };

    setPisaasCustomerInstancesMaintainRequesting = async (pisaasInstances) => {
        this.setState(
            {
                pisaasCustomerInstances: pisaasInstances
            });
    }

    logout = () => {
        this.authentication.logout(function () {
            history.push('/');
        });
    };

    renderPisaasCustomerInstanceInfo = (pisaasCustomerInstances, requesting) => {
        if (!pisaasCustomerInstances || pisaasCustomerInstances.length === 0) {
            return (
                <>
                    {requesting ?
                        <div className={"loading-container"} data-testid="trypi.loading.container">
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only" data-testid="trypi.loading.text">Requesting. This can take up to a minute.</span>
                        </div>
                        :
                        <></>
                    }
                </>
            );
        } else {
            return (
                <div>
                    {requesting ?
                        <div className={"loading-container"} data-testid="trypi.loading.container">
                            Requesting. This can take up to a minute.
                            <i className="fa fa-spinner fa-pulse fa-3x fa-fw"/>
                            <span className="sr-only" data-testid="trypi.loading.text">Requesting. This can take up to a minute.</span>
                        </div>
                        : null}
                    {pisaasCustomerInstances.map((pisaasInstance) => pisaasInstance.package_id === 8 ?
                        <PisaasInstanceInfo isAdmin={this.authentication.isAdmin()}
                                            refreshPisaasInstances={this.pisaasCustomerInstancesRefresh}
                                            piSaasInstance={pisaasInstance} key={pisaasInstance.pisaas_instance_id}/>
                        : <></>)}
                </div>
            )
        }
    };

    handleSignUp = () => {
        this.setState({
                loading: true,
                requestingPisaasCustomerInstances: true
            }
        )
        const {packageId} = this.state;

        api.pisaasUserSignup(this.loadAfterCreate, function (err) {
            console.log(err);
            toast.error("Failed to buy package", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, packageId);

    }

    allowCreation = () => {
        const trypiPackageId = 8;
        if (this.state.pisaasCustomerInstances.length >= 1) {
            return !(this.state.pisaasCustomerInstances.some(instance => instance.package_id === trypiPackageId))
        } else {
            return true;
        }

    };


    render() {
        return (
            <div className={"instances-container"} data-testid="trypi.instances.container">
                <Nav history={this.props.history}/>
                <div className={"instances-header gap-bottom-5"}>
                    <h1 className={"instances-heading"} data-testid="trypi.instances.heading">Enjoy your play time.</h1>
                    <InstancesButtons loading={this.state.loading} logout={this.logout} load={this.load}
                                      requestingTryPi={this.state.requestingPisaasCustomerInstances}
                                      allowCreation={this.allowCreation()}
                                      createTryPiInstance={true}
                                      handleSignUp={this.handleSignUp}
                                      createHasBeenClicked={this.state.createHasBeenClicked}
                    />

                </div>
                <div className="play-info" data-testid="trypi.playInfo">
                    <h2>Play with pi instances:</h2>
                    <ul>
                        <li>Click create to start your TryPi instance</li>
                        <li>The launch button will become available after around 5 minutes when the dashboard has
                            started up
                        </li>
                        <li>After 5 minutes, you may need to refresh to retrieve status updates</li>
                        <li>You will have access to your instance for 22 hours, after which your environment will be
                            decommissioned
                        </li>
                        <li>You will need to create a new instance if you wish to play after 22 hours</li>
                    </ul>
                </div>
                {this.state.loading ?
                    <Loading/> : this.renderPisaasCustomerInstanceInfo(this.state.pisaasCustomerInstances, this.state.requestingPisaasCustomerInstances)}
                {this.state.showPisaasCustomerSignUp ?
                    <PisaasCustomerSignUpPopUp togglePopUp={this.togglePisaasCustomerCreatePopUp}
                                               loadAfterCreate={this.loadAfterCreate}/> : <></>}
                <Footer/>
            </div>
        );
    }
}
